import { CDN_LEVEL_TRAVEL } from '@lt/components/constants/cdn';
import { pluralize } from '@lt/components/utils/userflow';
import type { GroupName } from '@lt/api/dist/methods/references/types';

import type { GroupsParams } from './types';

const plural = {
  countries: ['страна', 'страны', 'стран'],
  metaregions: ['впечатление', 'впечатления', 'впечатлений'],
};

export const groupParams: GroupsParams = {
  popularCountries: {
    label: 'Популярные страны',
    showMoreTitle: (count) => `Ещё ${count} ${pluralize(count, plural.countries)}`,
  },
  popularDirections: {
    label: 'Популярные направления',
  },
  metaregions: {
    label: 'Отдых по впечатлениям',
    showMoreTitle: (count) => `Ещё ${count} ${pluralize(count, plural.metaregions)}`,
  },
  allCountries: {
    label: '',
  },
  allMetaregions: {
    label: '',
  },
  regions: {
    label: 'Регион',
  },
  hotels: {
    label: 'Отель',
  },
  countries: {
    label: 'Страны',
  },
  any: {
    label: 'Любой',
  },
  previousSearches: {
    label: 'Предыдущие поиски',
  },
};

export const placeholder = (menuIsOpen?: boolean, searchType?: string): string => {
  if (!menuIsOpen) {
    return 'Куда хотите поехать?';
  }

  if (searchType === 'trip') {
    return 'Страна, город или регион';
  }

  return 'Страна, курорт или отель';
};

export const destinationPickerName = 'lt-destination-picker';

export const defaultExtendedGroupIds: GroupName[] = [
  'popularCountries',
  'metaregions',
  'popularDirections',
];

export const linkGroupDict = {
  allCountries: 'popularCountries',
  allMetaregions: 'metaregions',
  allDirections: 'directions',
};

export const START_OPTIONS_COUNT = 3;

export const DEFAULT_IMAGE = `${CDN_LEVEL_TRAVEL}/lt-modules-assets/main/header_bg.jpg`;
